import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

import "./style.css";
import { updateUserActivity } from "../../../redux/slices/userActivity";
import { deleteDuonut, getMyDuonuts } from "../../../services/duonut";
import { updateDeleteDuonutConfirmModal } from "../../../redux/slices/formDetails";
import { toast } from "react-toastify";

export default function ConfirmDeleteDuonut({ setDuonuts, fetchDuonut }) {
  const dispatch = useDispatch();
  const { active: modalActive, duonutId } = useSelector((state) => state.formDetails.deleteDuonutConfirmModal);

  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    dispatch(updateDeleteDuonutConfirmModal({ active: false, duonutId: null }));
  };

  const handleDelete = () => {
    if (!duonutId || duonutId === null) return handleClose();
    setIsLoading(true);
    deleteDuonut(duonutId, (err, res) => {
      if (err) {
        setIsLoading(false);
        fetchDuonut()
        handleClose();
        // toast.error("Something went wrong!");
        return;
      } else {
        // console.log("delete res", res.data)
        setIsLoading(false);
        fetchDuonut()
        handleClose();
        toast.success("Duonut deleted!");
      }
    });
  };

  return (
    <AnimatePresence>
      {modalActive && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
          className="modal_container confirm_replace_modal "
          onClick={handleClose}
        >
          <motion.div
            initial={{ scale: 0.7 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.7 }}
            transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
            className="modal_basic"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <div className="modal_header" style={{ textAlign: "center" }}>Confirm delete the Duonut?</div>
              <div className="modal_text" style={{ textAlign: "center" }}>This action cannot be undone!</div>
              <div className="action-buttons">
                <button className="btn btn-primary cancel-btn" onClick={handleClose}>
                  Cancel
                </button>
                <button disabled={isLoading} className="btn btn-primary" onClick={handleDelete}>
                  {isLoading ? "Deleting..." : "Confirm Delete"}
                </button>
              </div>
            </div>
            <div className="close-icon icon-button" onClick={handleClose}>
              <img src="/assets/icons/close.svg" alt="" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
